//PartnersPage.tsx
import { FC } from 'react'
import { usePortal } from '../hooks/usePortal'
import Breadcrumbs from '../components/Breadcrumbs'
import { createPortal } from 'react-dom'
import Articles from '../components/Articles'
import getArticles from '../api/getArticles'
import PartnerCard from '../components/PartnerCard'
import { ArticleData } from '../server/utils/getArticlesData'

const BREADCRUMBS = [
  {
    label: 'Главная',
    path: '/'
  },
  {
    label: 'Партнеры',
    path: '/partners'
  }
]

const PartnersPage: FC = () => {
  const { portal } = usePortal()

  return (
    <div className="page">
      <Breadcrumbs className="page__breadcrumbs" breadcrumbs={BREADCRUMBS} />
      {portal &&
        createPortal(<Breadcrumbs breadcrumbs={BREADCRUMBS} />, portal)}

      <header className="page__head">
        <h1>Партнеры</h1>
      </header>

      <div className="page__content">
        <Articles
          tabsNavigation
          noFilters
          search = {true}
          queryMode
          count={9}
          method={(options) => getArticles('/partners/list', options)}
          renderContent={({ items }, loading) => {
            return loading || items.length ? (
              <div className="app-grid _columns-3-1">
                {loading
                  ? Array.from({ length: 9 }).map((_, index) => {
                      return <PartnerCard key={index} loading />
                    })
                  : items.map((item: ArticleData) => (
                      <PartnerCard
                        key={item.id}
                        title={item.title}
                        contactItems={item.contactItems}
                        link={item.link}
                        socials={item.socials}
                        picture={
                          item.previewPicture || item.detailPicture || ''
                        }
                      />
                    ))}
              </div>
            ) : (
              'Нет данных'
            )
          }}
        />
      </div>
    </div>
  )
}

export default PartnersPage
